export const keyCustomCode = 'custom-form-plugin__code';
export const typeCustomCode = 'custom-form';
export const commandNameCustomCode = 'custom-form:open-modal';